import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, Form, change } from 'redux-form';
import { PrimaryButton, Icon, DLRichTextEditor } from 'appSrc/components/UI';
import { FormTextField, FormToggle } from 'appSrc/components/UI/ReduxForm';
import { DL_DRIVE_REGEX } from 'appSrc/utils';
import { ImageSelectModal } from 'appSrc/components/Shards';
import ListCoverImage from 'appSrc/components/List/CoverImage';
import style from './styles/style.module.css';


class StepVideoEdit extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            cover_image: this.props.initialValues.cover_image,
            description: this.props.initialValues.description || '',
            showCoverModal: false,
        };
    }
    componentDidUpdate( prevProps ) {
        if( prevProps.step === 'video_uri' && this.props.step === 'edit_video' ) {
            this.props.initialize( this.props.initialValues, true );
            this.setState( {
                cover_image: this.props.initialValues.cover_image,
                description: this.props.initialValues.description || '',
                showCoverModal: false,
            } );
        }
    }
    updateDescription = ( value ) => {
        this.setState( { description: value } );
        this.props.changeFieldValue( 'description', value );
    }
    updateCover = ( img ) => {
        var cover_image = img;
        if( DL_DRIVE_REGEX.test( cover_image ) ) {
            var id = cover_image.match( DL_DRIVE_REGEX )[ 1 ];
            cover_image = 'https://drive.google.com/a/desirelist.com/thumbnail?id=' + id;
        }
        this.props.changeFieldValue( 'cover_image', cover_image );
        this.setState( {
            cover_image: cover_image,
            showCoverModal: false,
        } );
    }
    submit = ( values ) => {
        var cover_image = this.state.cover_image;
        if( DL_DRIVE_REGEX.test( cover_image ) ) {
            var id = cover_image.match( DL_DRIVE_REGEX )[ 1 ];
            cover_image = 'https://drive.google.com/a/desirelist.com/thumbnail?id=' + id;
        }

        var ret = {
            block: {},
            video: {
                title: values.title,
                description: this.state.description,
                uri: values.uri,
                is_live: values.is_live,
                pro_name: values.pro_name,
                pro_profession: values.pro_profession,
                pro_email: values.pro_email,
                related_content_link: values.related_content_link,
                cover_image: cover_image,
            },
        };

        this.props.onSubmit( ret );
    }



    render() {
        const { handleSubmit } = this.props;

        var youtubeLink = this.props.initialValues.source == 'youtube' && this.props.initialValues.uri;

        const inlineStyle = this.props.step !== 'edit_video' ? { display: 'none' } : {};

        return (
            <Form className={ style.videoEditForm } style={ inlineStyle }
            onSubmit={ handleSubmit( this.submit ) }>
                <h2>Video Information</h2>
                <p>Here is what I was able to find about this video. Please edit and validate as neccesary.</p>
                <br/>
                <div className={ style.grid }>
                    <div>
                        <Field
                        id="title"
                        name="title"
                        label="Title"
                        fullWidth
                        component={ FormTextField } />

                        <div>
                            <DLRichTextEditor label="Description"
                            value={ this.state.description } onChange={ this.updateDescription } />
                        </div>

                        <Field
                        id="is_live"
                        name="is_live"
                        label="Live?"
                        style={ { margin: '15px 0', zIndex: 0 } }
                        component={ FormToggle } />
                    </div>

                    <div>
                        <p className={ style.label }>Cover Image</p>
                        <div className={ style.imageWrapper }
                        onClick={ () => { this.setState( { showCoverModal: true } ); } }>
                            <ListCoverImage coverImage={ this.state.cover_image } />
                            <span className={ style.editWrapper }>
                            EDIT<Icon source='fontAwesome' icon='fas/faPencilAlt' />
                            </span>
                        </div>

                        <Field style={ { margin: '15px 0' } }
                        id="pro_name"
                        name="pro_name"
                        label="Pro"
                        fullWidth
                        component={ FormTextField } />

                        <Field
                        id="pro_profession"
                        name="pro_profession"
                        label="Pro Title"
                        fullWidth
                        component={ FormTextField } />

                        <Field
                        id="pro_email"
                        name="pro_email"
                        label="Pro Email"
                        fullWidth
                        component={ FormTextField } />
                    </div>
                </div>

                <PrimaryButton
                label="Next"
                type="submit"
                fullWidth
                style={ { marginTop: '25px', zIndex: 0 } }/>

                <ImageSelectModal title='Cover Image Options' visible={ this.state.showCoverModal }
                options={ { img: this.state.cover_image, youtube: youtubeLink } }
                closeHandler={ () => { this.setState( { showCoverModal: false } ); } }
                onSubmit={ this.updateCover } />
            </Form>
        );
    }
}
StepVideoEdit.defaultProps = {
    onSubmit: () => {},
};

StepVideoEdit = reduxForm( {
    form: 'StepVideoEdit',
} )( StepVideoEdit );

const mapDispatchToProps = ( dispatch ) => {
    return {
        changeFieldValue: ( field, value ) => {
            dispatch( change( 'StepVideoEdit', field, value ) );
        },
    };
};


export default connect( null, mapDispatchToProps )( StepVideoEdit );
